import { getSpaceContractResponseSchema } from "@wakeloop/schemas";
import type {
  SpaceContract,
  WakeLoopRequestContext,
} from "@wakeloop/schemas/types";
import { buildWakeLoopRequestContextHeadersWithAuth } from "../config/request-headers";
import { toSpaceContractUrl } from "../protocol/urls";
import { fetchSpaceRequestWithTimeout } from "./fetch-with-timeout";
import { readGatewayJsonResponse } from "./gateway-response";

export async function fetchSpaceContract(input: {
  requestContext: WakeLoopRequestContext;
  baseUrl: string;
  space: string;
  password?: string;
}): Promise<SpaceContract> {
  const endpoint = toSpaceContractUrl(input.baseUrl, input.space);
  const response = await fetchSpaceRequestWithTimeout({
    url: endpoint,
    operation: "space.contract.read",
    init: {
      headers: await buildWakeLoopRequestContextHeadersWithAuth({
        requestUrl: endpoint,
        requestContext: input.requestContext,
        spacePassword: input.password,
      }),
    },
  });
  return await readGatewayJsonResponse({
    response,
    schema: getSpaceContractResponseSchema,
    invalidMessage: "invalid space contract response",
  });
}
